import { FailedRenewals } from "."
import { ExclamationCircleOutlined } from "@ant-design/icons"

export const FAILED_RENEWALS_ROUTES = [
  {
    path: "/failed-renewals/:subpage?",
    component: FailedRenewals
  }
]

export const FAILED_RENEWALS_NAVIGATION = [
  {
    title: "Failed Renewals",
    path: "/failed-renewals",
    submenu: false,
    icon: <ExclamationCircleOutlined />,
    iconActive: <ExclamationCircleOutlined />
  }
]
